export const linkReset = {
    color: 'inherit',
    cursor: 'inherit',
    textDecoration: 'inherit',
    '&:hover': {
        textDecoration: 'inherit',
        cursor: 'pointer',
        color: 'inherit',
    }
};